import React from "react";
import {
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  Form,
  FormInput,
  Button
} from "shards-react";
import { Link } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import ProjectFileDataService from "../../services/projectFile.service";
import { FcPlus, FcDownload } from "react-icons/fc";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {actions as AppActions} from "../../_stores/app.store";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import * as XLSX from "xlsx";
import authStore from "../../_stores/auth.store";

  const perPage = 10;
  const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const EXCEL_EXTENSION = ".xlsx";

class ViewProjectStructure extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectFileList:[],
      fileConfigNameTxt:"",
      fileConfigFilteredList:[]
    };

    this.aggridRef = React.createRef();

    this.retrieveProjectFiles = this.retrieveProjectFiles.bind(this);
    this.onChangeFileConfigNameTxt = this.onChangeFileConfigNameTxt.bind(this);
    this.deleteProjectFile = this.deleteProjectFile.bind(this);
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  componentDidMount() {
    this.retrieveProjectFiles();
  }

  componentDidUpdate(prevProps) {
      if (this.props.projectId != prevProps.projectId)
        this.retrieveProjectFiles();
    }

    retrieveProjectFiles(){
    AppActions.setLoading(true);  
  	ProjectFileDataService.getByProject(this.props.projectId).then((response) => {
		AppActions.setLoading(false);  
      this.setState({
				projectFileList:response.data.data,
        fileConfigFilteredList:response.data.data,
			})
  	}); 
	}

  deleteProjectFile(id){
    AppActions.setLoading(true);  
    ProjectFileDataService.delete(id).then((response) => {
        this.retrieveProjectFiles();
        AppActions.setLoading(false);  
				this.notify("success", "Project File Deleted");
			})
			.catch((error) => {
				const message =
					(error.response &&
						error.response.data &&
						error.response.data.message) ||
					error.message ||
					error.toString();
				this.setState({
					message: message,
				});
				this.notify("error", message);
        AppActions.setLoading(false);
			});
      
  }

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  onChangeFileConfigNameTxt(e){
    var str= e.target.value.toLowerCase();
    var fileConfigs = this.state.projectFileList.filter(function(data) {
      if(data.projectFileName.toString().toLowerCase().includes(str)){
        return true
      }
    });
    
    this.setState({
      fileConfigFilteredList: fileConfigs,
      fileConfigNameTxt: e.target.value
    });
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  exportToExcel() {
    const { projectFileList } = this.state;
    //console.log(projectFileList);
    const sheetdata = [];
    sheetdata.push(["Project Structure File", "Supplier Code", "Project File Name", "File", "Modified By", "Updated Date"]);
    for (let i = 0; i < projectFileList.length; i++) {
      const conItem = projectFileList[i];
      sheetdata.push([conItem.projectStructureId.projectStructureName, conItem.projectSupplierId.supplierCode, conItem.projectFileName, conItem.structureSupplierMapping.file,!(conItem.modifiedBy && conItem.modifiedBy.name) ? "admin" : conItem.modifiedBy.name, moment(new Date(conItem.updatedAt)).format("DD/MM/yyyy hh:mm:ss A")]);
    }
    this.prepWorkbookFromJson(sheetdata);
  }

  prepWorkbookFromJson(sheetdata) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer);
  }

  createUrlFromBlob(bufferData) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFile(objurl, "Project_File_" + new Date().getTime() + EXCEL_EXTENSION);
    URL.revokeObjectURL(objurl);
  }

  downloadFile(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  render() {
    const {
      projectFileList,
      fileConfigNameTxt,
      fileConfigFilteredList
    } = this.state;

    const columnDefs = [
      {headerName: "Project Structure File", field: "projectStructureId.projectStructureName", filter: true, sortable:true, width:"350"},
      {headerName: "Supplier Code", field: "projectSupplierId.supplierCode",filter: true, sortable:true,width:"130"},
      {headerName: "Project File Name", field: "projectFileName",filter: true,  sortable:true,width:"400"},
      {headerName: "File", field: "structureSupplierMapping.file",filter: true,  sortable:true},
      {headerName: "Modified By", field: "modifiedBy.name",filter: true,  sortable:true, width:"120",
        cellRendererFramework: (data) => {
          return (!data.value ? "admin" :  data.value)
          } 
      },
      {headerName: "Updated At", field: "updatedAt",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "action", field:"id", width:"120",
        cellRendererFramework: (data) => {
          return <>
              <Link title="Clone" className="text-warning mr-2" to={"/project/"+this.props.projectId+"/file/"+data.value+"/clone"}><RiCheckboxMultipleBlankLine size="20" /></Link>
              <Link title="Details" className="text-primary mr-2" to={"/project/"+this.props.projectId+"/file/"+data.value+"/detail"}><TiEyeOutline  size="20" /></Link>
              <Link title="Edit" className="text-success mr-2" to={"/project/"+this.props.projectId+"/file/"+data.value+"/edit"}><TiEdit  size="20" /></Link>
              {(authStore.getState().auth_reducer.user.role === "superadmin" || authStore.getState().auth_reducer.user.role === "admin") && (
                <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteProjectFile(data.value)}><TiDeleteOutline size="20" /></span>
              )}
              </>
        }
      }
    ]

    return (
        <>
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardHeader className="border-bottom">
                    <h6 className="m-0 float-left">Project File Configuration</h6>
                    <Link className="btn btn-primary ml-4 float-left" to={"/project/"+this.props.projectId+"/file/create/"}> <FcPlus /> Create New Configuration File</Link>
                    <Button variant="primary" className="ml-3 btn btn-success" onClick={this.exportToExcel}>
                      <FcDownload /> Export Supplier Data
                    </Button>
                    <Form className="float-left ml-5">
                        <FormInput
                          id="fileConfigNameTxt"
                          placeholder=" Project File Name"
                          value={fileConfigNameTxt}
                          onChange={this.onChangeFileConfigNameTxt}
                          className="width-300"
                        />
                      </Form>
                </CardHeader>
                <CardBody className="p-0 pb-3">

                  <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                    
                    <div className="example-header">
                      Page Size: &nbsp;
                      <select onChange={this.onPageSizeChanged} id="page-size">
                        <option value="10" selected={true}>
                          10
                        </option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                     
                    </div>
                    <AgGridReact
                        ref={this.aggridRef}
                        pagination={true}
                        rowHeight={50}
                        paginationPageSize={perPage}
                        columnDefs={columnDefs}
                        rowData={fileConfigFilteredList}>

                    </AgGridReact>
                  </div>
      {/* {console.log(fileConfigFilteredList)}
                  <table className="table mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          Project Structure File
                        </th>
                        <th scope="col" className="border-0">
                          Project Supplier Code
                        </th>
                        <th scope="col" className="border-0">
                          Project File Name
                        </th>
                       <th scope="col" className="border-0">
                          Created Date
                        </th>
                        {/*  <th scope="col" className="border-0">
                          Period Date
                        </th> *
                        <th scope="col" className="border-0">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    {fileConfigFilteredList && fileConfigFilteredList.map((item,index) => {
                      return(
                      <tr key={index+1}>
                        <td>{item.projectStructureId.projectStructureName}</td>
                        <td>{item.projectSupplierId.supplierCode}</td>
                        <td>{item.projectFileName}</td>
                        <td>{moment(new Date(item.createdAt)).format("Do MMM YYYY")}</td>
                        {/* <td>{moment(new Date(item.structureSupplierMapping.generationDate)).format("Do MMM YYYY")}</td>
                        <td>{moment(new Date(item.structureSupplierMapping.periodDate)).format("Do MMM YYYY")}</td> *
                        <td>
                          <Link className="text-warning" data-tip data-for="cloneTip"  to={"/project/"+this.props.projectId+"/file/"+item.id+"/clone"}><RiCheckboxMultipleBlankLine /></Link>
                          <ReactTooltip id="cloneTip" place="top" effect="solid">Clone</ReactTooltip>
                          <Link className="text-primary" data-tip data-for="detailTip"  to={"/project/"+this.props.projectId+"/file/"+item.id+"/detail"}><TiEyeOutline /></Link>
                          <ReactTooltip id="detailTip" place="top" effect="solid">Detail</ReactTooltip>
                          <Link className="text-success" data-tip data-for="editTip"  to={"/project/"+this.props.projectId+"/file/"+item.id+"/edit"}><TiEdit /></Link>
                          <ReactTooltip id="editTip" place="top" effect="solid">Edit</ReactTooltip>
                          {/* <span className="text-danger cursor-pointer" onClick={() => this.deleteProjectFile(item.id)}><TiDeleteOutline /></span> 
                              <ReactTooltip id="deleteTip" place="top" effect="solid">Delete</ReactTooltip> *
                        </td>
                      </tr>
                        )
                      })
                    }
                    </tbody>
                  </table> */}
                </CardBody>
              </Card>
              <ToastContainer />
            </Col>
          </Row>
        </>
        )
  }
}

export default ViewProjectStructure;
